import type { RootState } from "~/app/store";
import { selectProperAmountInCart } from "~/features/addToCart/redux/cartAmounts/cartAmountSelectors";
import { PURCHASE_PLACE_PARAM, PURCHASE_TYPE_PARAM } from "~/app/analytics/ga/recommendations/constants";

import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { PurchasePlace, PurchaseType } from "~/app/analytics/ga/recommendations/types";

export const selectAmountInCart =
  ({ product, packCode }: Pick<SelectPriceProps, "packCode" | "product">) =>
  (state: RootState) =>
    selectProperAmountInCart({
      productCode: product.base.code,
      packCode,
      priceReference: product.priceReference,
      isMultiPrice: product.isMultiPrice,
    })(state);

export interface SelectPriceProps {
  quantity: number;
  product: ProductDescriptor;
  packCode: string;
}

export function getPurchaseDataFromUrl() {
  const url = new URL(window.location.href);
  const purchasePlace = url.searchParams.get(PURCHASE_PLACE_PARAM) as PurchasePlace | undefined;
  const purchaseType = url.searchParams.get(PURCHASE_TYPE_PARAM) as PurchaseType | undefined;

  return {
    recommendationType: purchaseType,
    recommendationPlace: purchasePlace,
  };
}

export function appendPurchaseParams(pdpUrl: string, purchasePlace: PurchasePlace, purchaseType: PurchaseType) {
  if (pdpUrl.startsWith("/")) {
    pdpUrl = window.location.origin + pdpUrl;
  }
  const url = new URL(pdpUrl);
  const params = url.searchParams;
  params.set(PURCHASE_PLACE_PARAM, purchasePlace);
  params.set(PURCHASE_TYPE_PARAM, purchaseType);
  return url.toString();
}
